import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import ImageAccordion from './ImageAccordion';
import MockImageAccordion from './ShelfImageAccordion';
import ProductImageAccordion from './ProductImageAccordion';
import { scrollBarStyle } from '../../../utils/layoutConfig';

const accordionStyles = (active) => {
	return {
		transition: '.3s',
		fontWeight: active ? 'bold' : 'normal',
		borderBottom: active ? '2px solid #ECC94B' : 'none',
	};
};

const UploadImagesContent = ({ isOpen, viewId }) => {
	const [activeAccordion, setActiveAccordion] = React.useState(0);

	if (!isOpen) return null;

	const list = [
		<ImageAccordion {...{ viewId }} />,
		<MockImageAccordion {...{ viewId }} />,
		<ProductImageAccordion {...{ viewId }} />,
	];
	const accordions = [{ name: 'Imagens' }, { name: 'Shelf' }, { name: 'PDP' }];
	console.log(isOpen);
	return (
		<Box className={'teste'} {...popoverStyle}>
			<Flex gap={'8px'} mb={2}>
				{accordions.map((acc, index) => (
					<Box
						_hover={{ cursor: 'pointer' }}
						style={accordionStyles(index == activeAccordion)}
						onClick={(e) => setActiveAccordion(index)}
					>
						{acc.name}
					</Box>
				))}
			</Flex>
			<Box overflow={'auto'} maxH={'530px'} sx={scrollBarStyle}>
				{list[activeAccordion]}
			</Box>
		</Box>
	);
};

export default UploadImagesContent;

const popoverStyle = {
	boxShadow: '0px 0px 9px 0px #cecece',
	p: 2,
	bg: 'white',
	zIndex: 1,
	br: 2,
	position: 'absolute',
	top: '70px',
	right: 0,
	width: '430px',
	minH: '200px',
	transition: '.3s',
};
